import type { TableCell } from 'mdast';
import type { State } from '../state';

export function tableCell(state: State, node: TableCell): void {
	// rowIndex === 0 is the header row (falsy), subsequent rows are body cells
	const cellTypeName = state.rowIndex ? 'tableCell' : 'tableHeader';
	const cellType =
		state.schema.nodes[cellTypeName] ?? state.schema.nodes.table_cell ?? state.schema.nodes.td;

	const paragraphType = state.schema.nodes.paragraph;

	if (!cellType) {
		// Gracefully degrade: schema has no table cell node — render paragraph content only
		if (paragraphType) {
			state.openNode(paragraphType);
			state.parseTokens(node.children);
			state.closeNode();
		} else {
			state.parseTokens(node.children);
		}
		return;
	}

	state.openNode(cellType);
	if (paragraphType) {
		state.openNode(paragraphType);
		state.parseTokens(node.children);
		state.closeNode();
	} else {
		state.parseTokens(node.children);
	}
	state.closeNode();
}
